<template>
  <Dialog :hide-close-button="true" v-bind="$attrs">
    <template #header-title
      >Você tem conta bancária em algum dos seguintes bancos?</template
    >
    <template #content>
      Você tem chances de conseguir a oferta, mas é necessário ter conta
      bancária em um dos seguintes bancos:

      <ul>
        <li>Bradesco</li>
        <li>Itaú</li>
        <li>Santander</li>
        <li>Caixa Econômica</li>
      </ul>
    </template>
    <template #footer>
      <Button :busy="busy" @click="handleInteraction(true)">
        Sim, eu tenho
      </Button>
      <Button :busy="busy" type="outlined" @click="handleInteraction(false)">
        Não, não tenho
      </Button>
    </template>
  </Dialog>
</template>
<script>
import Button from '@/aasgard/components/buttons/Button.vue'
import Dialog from '@/aasgard/components/modals/Dialog.vue'
import { mapActions } from 'vuex'
export default {
  name: 'SimplicPreSelectOfferModal',
  components: {
    Button,
    Dialog,
  },
  props: {
    busy: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'submit'],
  methods: {
    ...mapActions({
      actEmitGaEvent: 'services/ga/actEmitGaEvent',
    }),
    handleInteraction(hasAccount) {
      const action = hasAccount ? 'yes' : 'no'

      this.actEmitGaEvent({
        eventCategory: 'simplic-pre-select-offer-ab-test',
        eventAction: action,
        eventLabel: action,
      })

      if (hasAccount) {
        this.$emit('submit')
      } else {
        this.$emit('close')
      }
    },
  },
}
</script>
<style lang="scss"></style>
